exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".check-off-item {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  padding: 4px 8px;\n  margin-bottom: 4px;\n  transition: background-color 1s ease;\n}\n.archived {\n  border-color: rgba(255, 0, 0, 0.5);\n  color: rgba(0, 0, 0, 0.5);\n}\n.checking {\n  background-color: orange;\n}\n.checked {\n  background-color: lawngreen;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/checkoffs/check-off-item/check-off-item.component.less
// module id = ./src/app/checkoffs/check-off-item/check-off-item.component.less
// module chunks = 0